import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface EmitterTableProps {
  rows: {
    id: string
    emitter: string
    efficiency: string
  }[]
}

const EmitterTable: FC<EmitterTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
        }}
      >
        <Table sx={{ minWidth: "1336px" }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell sx={{ width: '29px' }}>#</TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  borderRight: '1px solid #D7D7D7',
                }}
              >
                Emitter
              </TableCell>
              <TableCell
                sx={{
                  width: '1125px',
                }}
              >
                Efficiency
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  {row.emitter}
                </TableCell>
                <TableCell>{row.efficiency}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default EmitterTable
